import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { KEY_ENTER, KEY_RETURN } from 'keycode-js';
import { TRANSITION_TIMEOUT_SHORT } from 'common/constants';

import withAppearTransition from 'common/hoc/withAppearTransition';
import TrashIcon from 'common/icons/Trash';
import { IconContainer, LabelContainer, TemplateLibraryWrapper } from './FormTemplateLibraryItem.styled';

const WrapperWithTransition = withAppearTransition(TemplateLibraryWrapper);

export default class FormTemplateLibraryItem extends Component {
    static propTypes = {
        template: PropTypes.object.isRequired,
        templateLabel: PropTypes.string.isRequired,
        templateSubtitle: PropTypes.string,
        onClickTemplate: PropTypes.func.isRequired,
        onRemoveTemplate: PropTypes.func,
        disabled: PropTypes.bool.isRequired,
        isSelected: PropTypes.bool,
    };

    static defaultProps = {
        onRemoveTemplate: null,
        templateSubtitle: null,
        templateDescription: null,
        isSelected: false,
    };

    state = { removed: false };

    handleRemove = () => {
        this.setState(
            () => ({ removed: true }),
            () => setTimeout(() => this.props.onRemoveTemplate(this.props.template), TRANSITION_TIMEOUT_SHORT),
        );
    };

    handleOnClick = (event) => {
        if (!this.props.disabled) {
            this.props.onClickTemplate(event, this.props.template);
        }
    };

    handleKeyPress = (event) => {
        (event.which === KEY_ENTER || event.which === KEY_RETURN) &&
            this.props.onClickTemplate(event, this.props.template);
    };

    render() {
        const hasIcon = !!this.props.onRemoveTemplate;
        const { template, isSelected, disabled, templateLabel, templateSubtitle } = this.props;

        return (
            <WrapperWithTransition
                appear
                in={!this.state.removed}
                isSelected={isSelected}
                isDisabled={disabled}
                tabIndex={disabled ? '-1' : '0'}
                onKeyPress={this.handleKeyPress}
                data-qa={`FormTemplateLibraryItem__${template.id}`}
            >
                <LabelContainer
                    aria-disabled={disabled}
                    role="button"
                    onClick={this.handleOnClick}
                    data-qa="FormTemplateLibraryItem__add-element"
                >
                    <p>{templateLabel}</p>
                    <p>{templateSubtitle}</p>
                </LabelContainer>
                {hasIcon && (
                    <IconContainer onClick={this.handleRemove} data-qa="FormTemplateLibraryItem__delete-button">
                        <TrashIcon />
                    </IconContainer>
                )}
            </WrapperWithTransition>
        );
    }
}
